export enum RackFormatEnum {
  LETTERS = 'letters',
  NUMBERS = 'numbers',
}
